import * as React from 'react';

import { MobileGalleryFooter } from '../../components/MobileGalleryFooter';
import { INewbuildingSummaryCellValue } from '../../types/newbuildingsCompare';
import { NewbuildingCallToAction } from '../NewbuildingCallToAction';
import { NewbuildingChatButton } from '../NewbuildingChatButton';

export interface IMobileGalleryFooterContainerProps {
  newbuilding?: INewbuildingSummaryCellValue;
}

export function MobileGalleryFooterContainer({ newbuilding }: IMobileGalleryFooterContainerProps) {
  const hasChat = Boolean(
    newbuilding && [...newbuilding.builders, ...newbuilding.sellers].some(contact => contact.chat?.enabled),
  );

  return (
    <MobileGalleryFooter
      title={newbuilding?.name}
      call={
        newbuilding && (
          <NewbuildingCallToAction
            builders={newbuilding.builders}
            buttonText="Позвонить застройщику"
            fullWidth
            newbuildingId={newbuilding.id}
            sellers={newbuilding.sellers}
            showButtonIcon
            url={newbuilding.fullUrl}
          />
        )
      }
      chat={
        hasChat &&
        newbuilding && (
          <NewbuildingChatButton
            builders={newbuilding.builders}
            gallerySiteType="mobile"
            newbuildingId={newbuilding.id}
            sellers={newbuilding.sellers}
            size="L"
            url={newbuilding.fullUrl}
          />
        )
      }
    />
  );
}
